import { Button, Form, Input, Modal, Image } from "antd";
import { TextButton } from "components/TextButton";
import styled from "styled-components";

export const WithdrawModalWrapper = styled(Modal)`
  max-width: 450px;
  top: calc(calc(100% - 400px) / 2);
  @media(min-width: 1400px){
    min-width: 600px;
  }
  .ant-modal-content {
    background: #000;
    border-radius: 10px;
    border: #cff54d 1px solid;
    .ant-modal-body {
    }
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
`;
export const LabelWrapper = styled.label`
  font-size: 11px;
  margin-left: 6px;
  color: #fff;
  font-weight: 600;
  @media(min-width: 1400px){
    font-size: 14px;
  }
  @media(min-width: 1600px){
    font-size: 16px;
  }
`;

export const NoteText = styled.label`
  font-size: 13px !important;
  color: rgb(107, 107, 107);
  font-weight: 400;
  text-align: left;
  @media(min-width: 1400px){
    font-size: 14px !important;
  }
  @media(min-width: 1600px){
    font-size: 16px !important;
  }
`;
export const LabelValueWrapper = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.color || "#fff"};
  text-align: end;
  @media(min-width: 1400px){
    font-size: 14px;
  }
  @media(min-width: 1600px){
    font-size: 16px;
  }
`;

export const Wrapper = styled.div`
  margin: 0 56px;
  text-align: center;
`;

export const WrapperText = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const WrapperContent = styled.div`
  margin: 8px 0px 4px;
`;

export const TitleStyled = styled.p`
  font-size: 15px;
  color: #ffffff;
  font-weight: 600;
  @media(min-width: 1400px){
    font-size: 22px;
  }
  @media(min-width: 1600px){
    font-size: 26px;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  border-radius: 24px;
  border: 1px solid #cff54d;
  background-color: transparent;
  line-height: 18px;
  justify-content: space-between;
  display: flex;
`;
export const InputField = styled(Input)`
  width: 80%;
  background: transparent;
  border: none;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  :disabled,
  :disabled:hover {
    background-color: transparent !important;
    color: #fff !important;
  }
  @media(min-width: 1400px){
    font-size: 14px;
  }
  @media(min-width: 1600px){
    font-size: 16px;
  }
`;
export const WrapperButton = styled(TextButton)`
  margin: 5px;
  /* width: 50px; */
  height: 24px;
  padding: 0px 15px;
  background: #cff54d;
  border-radius: 80px;
  color: #000;
  border: none;
  font-weight: 700;
  :disabled,
  :disabled:hover {
    color: grey;
  }
  width: 70px;
  text-align: center;
  .ant-image {
    height: 0;
  }
  :hover {
    background: #cff54d;
    color: #000;
  }
`;

export const WithdrawButton = styled(TextButton)`
  border-radius: 10px;
  /* width: 100%; */
  border: none;
  font-weight: 700;
  height: 40px;
  display: flex;
  margin-top: -23px;
  background: transparent !important;
  color: #cff54d !important;
  justify-content: center;
  align-items: center;
  :disabled,
  :disabled:hover {
    background-color: transparent;
    opacity: 0.6;
    background-image: none !important;

  }
  :hover,
  :focus {
    background: transparent;
    color: #cff54d;
  }
  @media(min-width: 1400px){
    font-size: 16px;
  }
  @media(min-width: 1600px){
    font-size: 20px;
  }
`;

export const FormItemWrapper = styled(Form.Item)`
  margin: 0;
  .ant-form-item-control-input-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const FormItemInput = styled(Form.Item)`
  margin-bottom: 0px;
  padding: 0px;
`;

export const FormItem = styled(Form.Item)`
  margin-bottom: 0px;
  text-align: center;
  .ant-image {
    height: 0;
  }
  .ant-btn:before {
    background: transparent;
  }
`;

export const ButtonBackground = styled(Image)`
  position: relative;
  top: 6px;
  width: 150px;
`;
